import React, { createContext, useContext, useMemo, ReactNode, useEffect } from "react";
import createApp from "@shopify/app-bridge";
import type { ClientApplication } from "@shopify/app-bridge";
import Cookies from "js-cookie";

interface ShopifyAppBridgeProviderProps {
  children: ReactNode;
}

const ShopifyAppBridgeContext = createContext<ClientApplication<any> | null>(null);

export const useAppBridge = (): ClientApplication<any> | null => {
  return useContext(ShopifyAppBridgeContext);
};

export default function ShopifyAppBridgeProvider({
  children,
}: ShopifyAppBridgeProviderProps) {
  const host = new URLSearchParams(window.location.search).get("host");

  const appBridge = useMemo(() => {
    if (!host) {
      console.warn("⚠️ Shopify host param missing — skipping App Bridge init.");
      return null;
    }

    return createApp({
      apiKey: "5463ca5b6f352324e971025f4cf55421",
      host,
      forceRedirect: true,
    });
  }, [host]);

  useEffect(() => {
    const shop = new URLSearchParams(window.location.search).get("shop");
    const authToken = Cookies.get("authToken");

    if (shop && !authToken) {
      fetch(`${process.env.REACT_APP_BACKEND_URL}/auth?shop=${shop}`)
        .then(res => res.json())
        .then(data => {
          if (!data.installed) {
            // Shop not authorized yet — start OAuth
            window.location.href = `${process.env.REACT_APP_BACKEND_URL}/auth?shop=${shop}`;
          }
        });
    }
  }, []);


  // Always render children, even if App Bridge isn't ready
  return (
    <ShopifyAppBridgeContext.Provider value={appBridge}>
      {children}
    </ShopifyAppBridgeContext.Provider>
  );
}
